import { Box, Grid, Typography } from "@mui/material";
import React, { memo, useContext } from "react";
import Label from "../../../components/label";
import TextInput from "../../../components/textInput";
import { AppContext } from "../../../lib/Context";
import { useLocation } from "react-router-dom";

const SameConnections = () => {
  const { eBillingAddress, setEbillingAddress, userData } =
    useContext(AppContext);
  const location = useLocation();
  const isDetailPage = location.pathname === "/prospect-details";

  const handleChangeValue = (e) => {
    const { name, value } = e.target;
    const formattedValue = value.replace(/\b[a-zA-Z]/g, (char) =>
      char.toUpperCase()
    );
    setEbillingAddress((prev) => ({ ...prev, [name]: formattedValue }));
  };

  return (
    <Box mt={2} mb={5}>
      <Typography variant="h6" color={"text.charcoalGrey"}>
        Paper Billing Address
      </Typography>

      <Grid container mt={0} spacing={2}>
        <Grid item xs={12} sm={12} md={6}>
          <Label
            title={"1st line of paper billing address"}
            htmlFor={"ebilling-address1"}
          />
          <TextInput
            id={"ebilling-address1"}
            required
            variant="filled"
            value={eBillingAddress.address1}
            name={"address1"}
            onChange={handleChangeValue}
            readonly={isDetailPage}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <Label
            title={"2nd  line of paper billing address"}
            htmlFor={"ebilling-address2"}
          />
          <TextInput
            id={"ebilling-address2"}
            required
            variant="filled"
            value={eBillingAddress.address2}
            name={"address2"}
            onChange={handleChangeValue}
            readonly={isDetailPage}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Label title={"Town"} htmlFor={"ebilling-town"} />
          <TextInput
            id={"ebilling-town"}
            required
            variant="filled"
            value={eBillingAddress.town}
            name={"town"}
            onChange={handleChangeValue}
            readonly={isDetailPage}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Label title={"City"} htmlFor={"ebilling-city"} />
          <TextInput
            id={"ebilling-city"}
            required
            variant="filled"
            value={eBillingAddress.city}
            name={"city"}
            onChange={handleChangeValue}
            readonly={isDetailPage}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Label title={"Post code"} htmlFor={"ebilling-post-code"} />
          <TextInput
            id={"ebilling-post-code"}
            required
            variant="filled"
            value={eBillingAddress.postCode}
            name={"postCode"}
            onChange={handleChangeValue}
            readonly={isDetailPage}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default memo(SameConnections);
